import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { OnChanges } from '@angular/core';
import { PagerService } from './pager.service';


@Component({
  selector: 'app-pager',
  templateUrl: './pager.component.html',
  styleUrls: ['./pager.component.css'],
})
export class PagerComponent implements OnInit, OnChanges {
  @Input() items: any[];
  @Input() pageSize = 100;
  @Input() totalItemsCount = 0;
  @Output() onPageChanged = new EventEmitter<any>();
  // pager object
  pager: any = {};
  pages: any[];
  pagedItems: any[];
  @Input() currentPage;
  constructor(private pagerService: PagerService) {
       
   }

  ngOnInit() {
    this.pages = [];
  }

  ngOnChanges(changes: SimpleChanges) {
    this.pager = this.pagerService.getPager(this.totalItemsCount, this.currentPage, this.pageSize);
    
  }

  changePage(page) {
    this.currentPage = page;
    if (!this.items || this.items.length === 0) {
      this.onPageChanged.emit([]);
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.totalItemsCount, this.currentPage, this.pageSize);

    ;    // get current page of items
    this.pagedItems = this.items;

    this.onPageChanged.emit(page);
  }



  next() {
    this.changePage(this.currentPage + 1);
  }
  previous() {
    this.changePage(this.currentPage - 1);
  }

}
